module.exports = __webpack_public_path__ + "img/gateway1.fedede6e.png";